import type {
  IRicosToolbar,
  IToolbarItemConfigTiptap,
  PublisherProvider,
  ToolbarButtonRenderers,
} from './../../../ricos-types';
import { TOOLBARS } from './../../../editor-common';

import type { Topics } from '../../topics';
import type { ToolbarServices } from '../../types';
import { RicosToolbar } from '../ricos-toolbar';
import { megaToolbarItemsRenderers } from './mega-renderers';

type Toolbars = {
  formatting: IRicosToolbar<TOOLBARS.INLINE>;
  plugin: IRicosToolbar<TOOLBARS.PLUGIN>;
  footer: IRicosToolbar<TOOLBARS.FOOTER>;
  mobile: IRicosToolbar<TOOLBARS.MOBILE>;
  pluginMenu: IRicosToolbar<TOOLBARS.SIDE>;
};

export class MegaToolbar extends RicosToolbar<TOOLBARS.MEGA> {
  private toolbars: Toolbars;

  private itemsConfigs!: IToolbarItemConfigTiptap[];

  constructor(
    isMobile: boolean,
    services: ToolbarServices,
    toolbars: Toolbars,
    publishers: PublisherProvider<Topics>
  ) {
    super(isMobile, services, TOOLBARS.MEGA, publishers, undefined);
    this.toolbars = toolbars;

    const toolbar = this.isMobile ? this.toolbars.mobile : this.toolbars.formatting;

    const separatorButtonConfig = toolbar
      .getMegaToolbarItemsConfig()
      .find(({ id }) => id === 'separator');

    const undoRedoItemsConfigs = this.services.plugins
      .getTextButtons()
      .asArray()
      .filter(b => b.getButtonId() === 'UNDO' || b.getButtonId() === 'REDO')
      .map(b =>
        b.toToolbarItemConfig(
          this.services.editor.getPublicCommands(),
          this.services.editor.adapter.tiptapEditor,
          TOOLBARS.MEGA
        )
      );

    this.itemsConfigs = [
      ...undoRedoItemsConfigs,
      ...(separatorButtonConfig ? [separatorButtonConfig] : []),
    ];
  }

  getToolbarItemsConfig(): IToolbarItemConfigTiptap[] {
    return this.itemsConfigs;
  }

  getToolbarItemsRenderers(
    _referenceElement?: HTMLElement | null | undefined
  ): ToolbarButtonRenderers {
    return megaToolbarItemsRenderers;
  }
}
